import React from 'react';

import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import { CartSummary } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/CartSummary';
import { TermsAndConditionsType } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/TermsAndConditions/TermsAndConditions';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';

export interface CartTabProps {
	wizardData: BookingWizardData;
	selectedTrips: SelectedTrips;
	onUpdateWizardData: (newData: BookingWizardData) => void;
	setSelectedTrips: (trips: SelectedTrips) => void;
	setTermsAndConditionsTypes: (conditions: TermsAndConditionsType[]) => void;
	isMobileBookingWizard: boolean;
	/**
	 * This function's only purpose is to re-render the whole component...
	 */
	setRefresh: (refresh: boolean) => void;
	refresh: boolean;
	setTabIsLoading?: (isLoading: boolean) => void;
}

export function CartTab({
	wizardData,
	selectedTrips,
	onUpdateWizardData,
	setSelectedTrips,
	setTermsAndConditionsTypes,
	isMobileBookingWizard,
	setRefresh,
	refresh,
	setTabIsLoading,
}: CartTabProps) {
	return (
		<>
			<CartSummary
				wizardData={wizardData}
				selectedTrips={selectedTrips}
				onUpdateWizardData={onUpdateWizardData}
				setSelectedTrips={setSelectedTrips}
				setTermsAndConditionsTypes={setTermsAndConditionsTypes}
				setRefresh={setRefresh}
				refresh={refresh}
				tripSummaryLocation="cart"
				setTabIsLoading={setTabIsLoading}
			/>
		</>
	);
}
